<script>
import Layout from "../../layouts/main";
import { mapGetters, mapActions } from "vuex";
import appConfig from "@/app.config";

export default {
  page: {
    title: "User Analytics",
    meta: [{ name: "description", content: appConfig.description }],
  },
  name: "user-analytics",
  data() {
    return {
      user: {
        first_name: "",
        last_name: "",
      },
      full_name: "",
      user_id: "",
      charger_month: [],
      ercharger_month: [],
      pre_auth_earning: [],
      final_charge: [],
      cancel_order: [],
      confirm_order: [],
      valueOptions: [],
      statData: [],
      series: [],
      erseries: [],
      chartOptions: {},
      erchartOptions: {},
      greet: "",
      navType: "year",
      ernavType: "year",
    };
  },
  components: {
    Layout,
  },
  computed: mapGetters("user", [
    "getUserBookingReportByYear",
    "getUserEarningReportByYear",
    "totalBookingUserUnit",
    "totalBookingUserTime"
  ]),
  methods: {
    ...mapActions("user", [
      "getUser",
      "getMonthWiseUserBookingReport",
      "getMonthWiseUserEarningReport",
    ]),
    choice(options) {
      this.navType = options;
      if (options == "week") {
        this.getMonthWiseUserBookingReport({
          user_id: this.convertDecodeId(this.$route.params.user_id),
          type: "week",
        }).then(() => {
          this.charger_month = this.getUserBookingReportByYear.map((x) => x.x);
          this.confirm_order = this.getUserBookingReportByYear.map(
            (x) => x.y.confirm_orders
          );
          this.cancel_order = this.getUserBookingReportByYear.map(
            (x) => x.y.cancel_orders
          );
          this.chartOptions = {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.charger_month,
            },
            colors: ["#556ee6", "#f1b44c", "#34c38f"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          };
          this.series = [
            {
              name: "Confirm Booking",
              data: this.confirm_order,
            },
            {
              name: "Cancel Booking",
              data: this.cancel_order,
            },
          ];
        });
      } else if (options == "month") {
        this.getMonthWiseUserBookingReport({
          user_id: this.convertDecodeId(this.$route.params.user_id),
          type: "month",
        }).then(() => {
          this.charger_month = this.getUserBookingReportByYear.map((x) => x.x);
          this.confirm_order = this.getUserBookingReportByYear.map(
            (x) => x.y.confirm_orders
          );
          this.cancel_order = this.getUserBookingReportByYear.map(
            (x) => x.y.cancel_orders
          );
          this.chartOptions = {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.charger_month,
            },
            colors: ["#556ee6", "#f1b44c", "#34c38f"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          };
          this.series = [
            {
              name: "Confirm Booking",
              data: this.confirm_order,
            },
            {
              name: "Cancel Booking",
              data: this.cancel_order,
            },
          ];
        });
      } else {
        this.getMonthWiseUserBookingReport({
          user_id: this.convertDecodeId(this.$route.params.user_id),
          type: "year",
        }).then(() => {
          this.charger_month = this.getUserBookingReportByYear.map((x) => x.x);
          this.confirm_order = this.getUserBookingReportByYear.map(
            (x) => x.y.confirm_orders
          );
          this.cancel_order = this.getUserBookingReportByYear.map(
            (x) => x.y.cancel_orders
          );
          this.chartOptions = {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.charger_month,
            },
            colors: ["#556ee6", "#f1b44c", "#34c38f"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          };
          this.series = [
            {
              name: "Confirm Booking",
              data: this.confirm_order,
            },
            {
              name: "Cancel Booking",
              data: this.cancel_order,
            },
          ];
        });
      }
    },
    erchoice(options) {
      this.ernavType = options;
      if (options == "week") {
        this.getMonthWiseUserEarningReport({
          user_id: this.convertDecodeId(this.$route.params.user_id),
          type: "week",
        }).then(() => {
          this.ercharger_month = this.getUserEarningReportByYear.map((x) => x.x);
          this.pre_auth_earning = this.getUserEarningReportByYear.map(
            (x) => x.y.pre_auth_charge
          );
          this.final_charge = this.getUserEarningReportByYear.map(
            (x) => x.y.final_charge
          );
          this.erchartOptions = {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.ercharger_month,
            },
            colors: ["#556ee6", "#f1b44c", "#34c38f"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          };
          this.erseries = [
            {
              name: "Pre Auth Earning",
              data: this.pre_auth_earning,
            },
            {
              name: "Final Earning",
              data: this.final_charge,
            },
          ];
        });
      } else if (options == "month") {
        this.getMonthWiseUserEarningReport({
          user_id: this.convertDecodeId(this.$route.params.user_id),
          type: "month",
        }).then(() => {
          this.ercharger_month = this.getUserEarningReportByYear.map((x) => x.x);
          this.pre_auth_earning = this.getUserEarningReportByYear.map(
            (x) => x.y.pre_auth_charge
          );
          this.final_charge = this.getUserEarningReportByYear.map(
            (x) => x.y.final_charge
          );
          this.erchartOptions = {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.ercharger_month,
            },
            colors: ["#556ee6", "#f1b44c", "#34c38f"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          };
          this.erseries = [
            {
              name: "Pre Auth Earning",
              data: this.pre_auth_earning,
            },
            {
              name: "Final Earning",
              data: this.final_charge,
            },
          ];
        });
      } else {
        this.getMonthWiseUserEarningReport({
          user_id: this.convertDecodeId(this.$route.params.user_id),
          type: "year",
        }).then(() => {
          this.ercharger_month = this.getUserEarningReportByYear.map((x) => x.x);
          this.pre_auth_earning = this.getUserEarningReportByYear.map(
            (x) => x.y.pre_auth_charge
          );
          this.final_charge = this.getUserEarningReportByYear.map(
            (x) => x.y.final_charge
          );
          this.erchartOptions = {
            chart: {
              stacked: true,
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                endingShape: "rounded",
              },
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: this.ercharger_month,
            },
            colors: ["#556ee6", "#f1b44c", "#34c38f"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          };
          this.erseries = [
            {
              name: "Pre Auth Earning",
              data: this.pre_auth_earning,
            },
            {
              name: "Final Earning",
              data: this.final_charge,
            },
          ];
        });
      }
    },
    userUpdateSeriesLine() {
      this.$refs.realtimeChart.updateSeries(
        [
          {
            data: this.series[0].data,
          },
          {
            data: this.series[1].data,
          },
        ],
        false,
        true
      );
    },
    showUserData(user_id) {
      //   let data = {
      //     id: this.convertDecodeId(user_id),
      //   };
      this.getUser({ id: user_id }).then((response) => {
        const { first_name, last_name } = response.data.result;
        this.user = { first_name, last_name };
        let final_last_name = "";
        let final_first_name = "";
        if (this.user.last_name == null) {
          final_last_name = "";
        } else {
          final_last_name = this.user.last_name;
        }
        if (this.user.first_name == null) {
          final_first_name = "";
        } else {
          final_first_name = this.user.first_name;
        }
        this.full_name = final_first_name + " " + final_last_name;
      });
      //this.showPublicCharger(data);
    },
    convertDecodeId(id) {
      return (this.user_id = atob(id));
    },
  },
  mounted() {
    this.showUserData(this.$route.params.user_id);
    this.choice("year");
    this.erchoice("year");
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bxs-bar-chart-alt-2"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ full_name }}</h4>
              <p>
                <router-link :to="{ name: 'user-report-details' }"
                  >User Report</router-link
                >
                > Analytics
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-12">
                <div class="card">
                  <div class="card-body">
                    <div class="float-right">
                      <ul class="nav nav-pills">
                        <li class="nav-item">
                          <a
                            v-bind:class="{ ' active': this.navType == 'week' }"
                            class="nav-link"
                            href="javascript: void(0);"
                            v-on:click="choice('week')"
                            >This Week</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            v-bind:class="{ ' active': this.navType == 'year' }"
                            class="nav-link"
                            href="javascript: void(0);"
                            v-on:click="choice('year')"
                            >This Year</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            v-bind:class="{ ' active': this.navType == 'month' }"
                            class="nav-link"
                            href="javascript: void(0);"
                            v-on:click="choice('month')"
                            >This Month</a
                          >
                        </li>
                      </ul>
                    </div>
                    <h4 class="card-title mb-4">{{ full_name }} Booking Report</h4>
                    <h4 class="card-title mb-4">
                      Total Charging Unit :- {{ totalBookingUserUnit }}
                    </h4>
                    <h4 class="card-title mb-4">
                      Total Charging Time :- {{ totalBookingUserTime }} min
                    </h4>
                    <apexchart
                      ref="realtimeChart"
                      class="apex-charts"
                      type="bar"
                      dir="ltr"
                      height="362"
                      :series="series"
                      :options="chartOptions"
                    ></apexchart>
                  </div>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="card">
                  <div class="card-body">
                    <div class="float-right">
                      <ul class="nav nav-pills">
                        <li class="nav-item">
                          <a
                            v-bind:class="{ ' active': this.ernavType == 'week' }"
                            class="nav-link"
                            href="javascript: void(0);"
                            v-on:click="erchoice('week')"
                            >This Week</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            v-bind:class="{ ' active': this.ernavType == 'year' }"
                            class="nav-link"
                            href="javascript: void(0);"
                            v-on:click="erchoice('year')"
                            >This Year</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            v-bind:class="{ ' active': this.ernavType == 'month' }"
                            class="nav-link"
                            href="javascript: void(0);"
                            v-on:click="erchoice('month')"
                            >This Month</a
                          >
                        </li>
                      </ul>
                    </div>
                    <h4 class="card-title mb-4">{{ full_name }} Earning Report</h4>
                    <apexchart
                      ref="realtimeChart"
                      class="apex-ercharts"
                      type="bar"
                      dir="ltr"
                      height="362"
                      :series="erseries"
                      :options="erchartOptions"
                    ></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.page-title-box {
  padding-bottom: 24px;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4 {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px !important;
}
.icon-main-page .page-title-left {
  display: flex;
  align-items: center;
}
.avatar-main-icon .avatar-xs {
  margin-top: -20px;
}
</style>
